import { render, staticRenderFns } from "./OscillographyChartLegends.vue?vue&type=template&id=0353c586&scoped=true&"
import script from "./OscillographyChartLegends.vue?vue&type=script&lang=js&"
export * from "./OscillographyChartLegends.vue?vue&type=script&lang=js&"
import style0 from "./OscillographyChartLegends.vue?vue&type=style&index=0&id=0353c586&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0353c586",
  null
  
)

export default component.exports